export function warn(...msg: string[]) {
    console.warn(`[mdk warn]: `, ...msg)
}